var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { staticClass: "q-mb-md" },
    [
      _c(
        "q-collapsible",
        {
          attrs: { icon: "fas fa-filter", label: _vm.getNameFilter },
          on: { click: _vm.toggle },
          model: {
            value: _vm.open,
            callback: function($$v) {
              _vm.open = $$v
            },
            expression: "open"
          }
        },
        [
          _vm.options
            ? _c("div", { staticClass: "row gutter-sm" }, [
                _vm.options.branch_types && _vm.options.branch_types.length
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            filter: "",
                            "autofocus-filter": "",
                            chips: "",
                            options: _vm.options.branch_types,
                            multiple: "",
                            "float-label": _vm.$t("branch_type"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.branch_type,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "branch_type", $$v)
                            },
                            expression: "filters.branch_type"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-chips-input",
                      {
                        attrs: {
                          "float-label": _vm.$t("headquarter"),
                          filter: "",
                          "autofocus-filter": ""
                        },
                        on: { remove: _vm.removeHeadquarter },
                        model: {
                          value: _vm.filters.companies_label,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "companies_label", $$v)
                          },
                          expression: "filters.companies_label"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: {
                            debounce: 500,
                            "min-characters": 1,
                            "max-results": 100
                          },
                          on: {
                            search: _vm.fetchHeadquarters,
                            selected: _vm.selectHeadquarter
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "q-chips-input",
                      {
                        attrs: { "float-label": _vm.$t("managers") },
                        on: { remove: _vm.removeManager },
                        model: {
                          value: _vm.filters.managers_list,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "managers_list", $$v)
                          },
                          expression: "filters.managers_list"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: {
                            debounce: 500,
                            "min-characters": 3,
                            "value-field": function(v) {
                              return v.full_name + " - " + v.email
                            }
                          },
                          on: {
                            search: _vm.searchManager,
                            selected: _vm.selectManager
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.options.statuses
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            multiple: "",
                            options: _vm.options.statuses,
                            "float-label": _vm.$t("status"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.filters.status,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "status", $$v)
                            },
                            expression: "filters.status"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "negative",
                    label: _vm.$t("clear_filters"),
                    icon: "fas fa-eraser"
                  },
                  on: {
                    click: function($event) {
                      return _vm.clearFilter()
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label: _vm.$t("apply_filter_plural"),
                    icon: "fas fa-filter"
                  },
                  on: {
                    click: function($event) {
                      return _vm.requestFiltered()
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }